export const userModel = {
  userCode: null,
  userName: '',
  entityCode: null,
  accessOptions: [],
  platform: null,
  usuariName: '',
  headquartersCode: null,
  headquartersShort: '',
  headquartersName: '',
  attentionType: null,
  assignmentDetail: {},
};

export const isAuthenticatedUser = ({ responseStatus, responseCode }) =>
  responseStatus === 200 && responseCode === '00';

export const accessOptionsByUser = (accessOptions, allAccessOptions) => {
  return accessOptions
    .map((option) => {
      const optionFound = allAccessOptions.find(
        (value) => value.optionCode === option.optionCode
      );
      if (optionFound) {
        const { icon, path } = optionFound || {};
        const children = option.children
          ? option.children.map((item) => {
              const childrenFound =
                optionFound.items &&
                optionFound.items.find(
                  (itemChildren) => item.optionCode === itemChildren.optionCode
                );
              return { ...item, path: childrenFound?.path };
            })
          : undefined;
        return { ...option, icon, path: path, children };
      }
    })
    .filter((value) => value !== undefined);
};

export const isLogoutUser = ({ responseStatus, responseCode }) =>
  responseStatus === 200 && responseCode === '00';
